
import barba from '@barba/core';
import Headroom from "headroom.js";
import { doc } from 'prettier';

export default class{

    constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }

	init(){
        const vh = (coef) => (window.innerHeight * (coef/100));
        const index = document.querySelector('#p-index')
        
        const header = document.getElementById('l-header');
        if(header){
            const headroom  = new Headroom(header,{
                "offset": (index) ?  vh(80) : 0,
            });
            headroom.init(); 
        }

        const hamburger = document.getElementById('js-hamburger');
        if(hamburger){
            const hamburgerHeadroom  = new Headroom(hamburger,{
                "offset": (index) ?  vh(70) : vh(50),
            });
            hamburgerHeadroom.init(); 
        }
        if(index){
            const logo = document.querySelector('.l-header__logo--link') 
            logo.classList.remove('-lower')
            hamburger.classList.remove('-lower')
        }else{
            const logo = document.querySelector('.l-header__logo--link') 
            logo.classList.add('-lower')
            hamburger.classList.add('-lower')
        }
	}
}